const BREAKPOINT = 1280;

const toggler = document.getElementById('mobileMenuToggle');
const nav = document.getElementById('mainNav');

if (toggler && nav) {
    // Uložíme původní pozici v DOM — potřebujeme ji pro obnovení po zavření
    const navOriginalParent = nav.parentElement;
    const navOriginalNextSibling = nav.nextSibling; // null = byl poslední child

    // Backdrop
    const backdrop = document.createElement('div');
    backdrop.className = 'mobile-menu-backdrop';
    document.body.appendChild(backdrop);

    const closeBtn = nav.querySelector('.mobile-menu-close');

    function isMobile() {
        return window.innerWidth < BREAKPOINT;
    }

    function restoreNav() {
        // insertBefore(node, null) === appendChild — funguje i když byl poslední child
        navOriginalParent.insertBefore(nav, navOriginalNextSibling);
    }

    function openMenu() {
        // Portal: přesuneme nav do <body> teprve TEĎ, těsně před otevřením.
        // Tím ho vymaníme ze stacking contextu .header (z-index:1030)
        // a z-index:1050 se porovnává přímo v root kontextu (nad backdropem 1045).
        document.body.appendChild(nav);

        // Reflow nutný, aby CSS transition správně spustila od původní hodnoty
        nav.getBoundingClientRect();

        nav.classList.add('is-open');
        backdrop.classList.add('is-active');
        document.body.style.overflow = 'hidden';
        toggler.setAttribute('aria-expanded', 'true');

        // Přesun focusu na zavírací tlačítko
        window.requestAnimationFrame(() => {
            closeBtn?.focus();
        });
    }

    function closeMenu(returnFocus = true) {
        nav.classList.remove('is-open');
        backdrop.classList.remove('is-active');
        document.body.style.overflow = '';
        toggler.setAttribute('aria-expanded', 'false');

        // Zavři všechna podmenu
        nav.querySelectorAll('.nav-item.dropdown.is-open').forEach(item => {
            item.classList.remove('is-open');
            item.querySelector('.dropdown-menu')?.classList.remove('is-open');
        });

        // Po dokončení transition vrátime nav zpátky na původní místo v DOM,
        // aby Bootstrap's .navbar-expand-xl .navbar-collapse fungoval na desktopu.
        nav.addEventListener('transitionend', restoreNav, {once: true});

        if (returnFocus) {
            toggler.focus();
        }
    }

    // Hamburger
    toggler.addEventListener('click', () => {
        if (!isMobile()) return;
        nav.classList.contains('is-open') ? closeMenu() : openMenu();
    });

    // Zavírací tlačítko v panelu
    closeBtn?.addEventListener('click', () => closeMenu(true));

    // Backdrop klik
    backdrop.addEventListener('click', () => closeMenu(false));

    // Klávesa Escape & Focus trap
    document.addEventListener('keydown', e => {
        if (!nav.classList.contains('is-open')) return;

        if (e.key === 'Escape') {
            e.preventDefault();
            closeMenu(true);
            return;
        }

        if (e.key === 'Tab') {
            const focusableElements = nav.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])');
            if (focusableElements.length === 0) return;

            const firstElement = focusableElements[0];
            const lastElement = focusableElements[focusableElements.length - 1];

            if (e.shiftKey) {
                if (document.activeElement === firstElement) {
                    e.preventDefault();
                    lastElement.focus();
                }
            } else {
                if (document.activeElement === lastElement) {
                    e.preventDefault();
                    firstElement.focus();
                }
            }
        }
    });

    // Resize na desktop → okamžitě obnovit bez čekání na transition
    window.addEventListener('resize', () => {
        if (isMobile()) return;
        if (nav.parentElement !== navOriginalParent) {
            nav.classList.remove('is-open');
            backdrop.classList.remove('is-active');
            document.body.style.overflow = '';
            toggler.setAttribute('aria-expanded', 'false');
            nav.querySelectorAll('.nav-item.dropdown.is-open').forEach(item => {
                item.classList.remove('is-open');
                item.querySelector('.dropdown-menu')?.classList.remove('is-open');
            });
            restoreNav();
        }
    });

    // ─── Podmenu accordion (pouze mobil) ────────────────────────────────────
    // Capture fáze + stopImmediatePropagation: Bootstrap Dropdown (bubble fáze
    // na document) událost nedostane → nezapne mega menu na pozadí.
    nav.querySelectorAll('.nav-item.dropdown .dropdown-toggle').forEach(toggle => {
        toggle.addEventListener('click', e => {
            if (!isMobile()) return; // desktop nechej Bootstrapu

            e.preventDefault();
            e.stopImmediatePropagation();

            const item = toggle.closest('.nav-item.dropdown');
            const dropdown = item?.querySelector('.dropdown-menu');
            if (!item || !dropdown) return;

            const isOpen = item.classList.contains('is-open');

            // Zavři ostatní
            nav.querySelectorAll('.nav-item.dropdown.is-open').forEach(other => {
                if (other !== item) {
                    other.classList.remove('is-open');
                    other.querySelector('.dropdown-menu')?.classList.remove('is-open');
                }
            });

            // Přepni aktuální
            item.classList.toggle('is-open', !isOpen);
            dropdown.classList.toggle('is-open', !isOpen);
        }, true); // capture fáze
    });
}
